module.exports = __webpack_public_path__ + "static/media/pindah-nikah.de1177b1.png";